import React from 'react';
import styled from 'styled-components';
import media from '../styles/media.style';
import { MOBILE_PADDING, PAGE_WIDTH } from '../styles/variables.style';

const Section = styled.section`
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  max-width: ${PAGE_WIDTH + MOBILE_PADDING * 2}px;
  padding: 40px ${MOBILE_PADDING}px;
  width: 100%;
`;

const Button = styled.div`
  border: 1px solid black;
  border-radius: 50px;
  cursor: pointer;
  height: 60px;
  position: relative;
  width: 60px;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -25%) rotate(45deg);

    border-left: 2px solid black;
    border-top: 2px solid black;
    height: 25%;
    width: 25%;
  }

  ${media.tabletL`
    height: 80px;
    width: 80px;
  `};

  ${media.desktop`
    height: 100px;
    width: 100px;
  `};
`;

const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
};

const ScrollToTopButton = () => (
  <Section>
    <Button onClick={scrollToTop} />
  </Section>
);

export default ScrollToTopButton;



// WEBPACK FOOTER //
// ./src/components/ScrollToTopButton.js